export enum FormFieldHandlers {
  Multiplex = 'multiplex',
  EnrollCollaborator = 'collaborator',
}
